<template>
	<form @submit.prevent="save">
		<vs-card class="flex flex-col justify-between p-5" fixedHeight style="min-height: 70vh">
			<ResponseAlert ref="response" />			
			<vs-row class="pt-5">
				<div class="w-full md:w-1/4 lg:w-3/12 mb-5 md:mb-0 lg:pr-2">
					<img :src="getUrlOfFile(vars.image, true)" alt="image-profile" class="w-3/4 md:w-full block m-auto">
					<vs-button color="primary" type="border" icon="upload_file" class="w-full mt-3" @click="$refs.file_upload.click()">
						<span class="text-xs">Upload Photo</span>
					</vs-button>
					<input ref="file_upload" type="file" accept="image/png, image/gif, image/jpeg, image/jpg"
						v-on:change="AddPhoto" hidden />
				</div>
				<div class="w-full md:w-3/4 lg:w-9/12 md:px-5">
					<vs-row>
						<div class="md:w-2/3 w-full mb-5 pr-1">
							<vs-input 
									autocomplete="off"
									v-validate="'required'" 
									label="Name" 
									name="name" 
									type="text"
									v-model="models.name" 
									class="w-full"/>
							<span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>
						</div>
						<div class="md:w-1/3 w-full mb-5 pl-1">
							<label class="pl-2 text-sm" for="brand">Brand</label>
							<v-select
								id="brand"
								v-validate="'required'" 
								name="brand" 
								:clearable="false"
								v-model="models.brandId"
								:reduce="brand => brand.value" 
								:options="masters.brands"
								label="text"
							/>
							<span class="text-danger text-sm" v-show="errors.has('brand')">{{ errors.first('brand') }}</span>

						</div>
					</vs-row>
					<div class="w-full mb-5">
						<label for="description">Description</label>

						<quill-editor
							v-model="models.description"
						/>
					</div>

					<div class="w-full mb-5 flex flex-col md:flex-row">
						<div class="w-full md:w-1/2 md:pr-2 mb-3 md:mb-0">
							<label class="pl-2 text-sm" for="type">Type</label>
							<v-select
							id="type"
								:clearable="false"
								v-model="models.type"
								:reduce="brand => brand.value" 
								:options="masters.types"
								label="text"
							/>
						</div>
						<div v-if="models.type === 'voucher'" class="w-full md:w-1/2">
							<vs-input 
									autocomplete="off"
									label="Voucher Code" 
									type="text"
									v-validate="'required'"
									name="code" 
									v-model="code"
									@keydown.space.prevent
									class="w-full"/>
							<span class="text-danger text-sm" v-show="errors.has('code')">{{ errors.first('code') }}</span>

						</div>
						<div v-else class="w-full md:w-1/2">
							<div class="w-full">
								<div class="relative border-2">
									<label class="pl-2" for="">Price</label>
									<vs-input
										autocomplete="off"
										v-validate="'required'"
										name="price" 
										@keypress="checkValidationNumber"
										v-model="price" 
										type="tel"
										icon-no-border icon="p"
										class="w-full"/>
									<span class="absolute text-sm font-medium" style="top: 26px; left: 15px">Rp.</span>
								</div>
								<span class="text-danger text-sm" v-show="errors.has('price')">{{ errors.first('price') }}</span>
							</div>
						</div>
					</div>

					<vs-row>
						<div class="w-full md:w-1/3">
							<div class="w-full mb-5">
								<vs-input 
									autocomplete="off"
									v-validate="'required'" 
									label="Stock" 
									name="stock"
									v-model="stock"
									@keypress="checkValidationNumber"
									type="tel"
									class="w-full"/>
								<span class="text-danger text-sm" v-show="errors.has('stock')">{{ errors.first('stock') }}</span>
							</div>
						</div>
						<div class="w-full md:w-1/3 md:pl-2">
							<div class="w-full mb-5">
								<vs-input 
									autocomplete="off"
									v-validate="'required'" 
									label="Point" 
									name="point"
									v-model="point"
									@keypress="checkValidationNumber"
									type="tel"
									class="w-full"/>
								<span class="text-danger text-sm" v-show="errors.has('point')">{{ errors.first('point') }}</span>
							</div>
						</div>
					</vs-row>

					<div class="w-full mb-5">
						<label class="pl-1 text-sm" for="status">Status</label>
						<ul id="status" class="flex mt-2">
							<li>
								<vs-radio v-model="models.isActive" vs-name="status" :vs-value="true" class="mr-5">Active</vs-radio>
							</li>
							<li>
								<vs-radio v-model="models.isActive" vs-name="status" :vs-value="false">Inactive</vs-radio>
							</li>
						</ul>
						<span class="text-danger text-sm" v-show="errors.has('status')">{{ errors.first('status') }}</span>
					</div>
				</div>
			</vs-row>

			<div slot="footer" class="justify-center">
				<vs-button button="submit" color="primary" type="filled" class="mr-3">Save</vs-button>
				<vs-button @click="$router.go(-1)" color="rgb(172,172,172)" type="border">Cancel</vs-button>
			</div>
		</vs-card>
	</form>
</template>

<script>
	import api from '@/utils/api.js'
	import {
		getUrlOfFile,
		uploadFile,
		checkValidationNumber
	} from '@/utils/helpers.js';

	export default {
		name: 'FormProduct',
		data() {
			return {
				config: {
					uri: this.$route.meta.link,
				},
				models: {
					name: '',
					image: '',
					type: 'product',
					code: '',
					description: '',
					price: '',
					stock: '',
					point: '',
					brandId: null,
					isActive: true,
				},
				masters: {
					brands: [
						{
							text: "Select brand",
							value: null
						}
					],
					types: [
						{
							text: "Product",
							value: "product"
						},
						{
							text: "Voucher",
							value: "voucher"
						},
					]
				},
				vars: {
					image: '',
					price: '',
					stock: '',
					point: '',
				},
				getUrlOfFile,
				checkValidationNumber
			}
		},
		created() {
			this.getById();
			this.getBrands()
		},
		computed: {
			point: {
				get() {
					return this.vars.point
				}, 
				set(val) {
					let raw = val.replace(/\D/g, '');
					if(raw === '') raw = 0
					this.vars.point = parseFloat(raw).toLocaleString().replace(/[.,]/g, m => m === '.' ? ',' : '.')
					this.models.point = Number(raw)
				}
			},
			stock: {
				get() {
					return this.vars.stock
				}, 
				set(val) {
					let raw = val.replace(/\D/g, '');
					if(raw === '') raw = 0
					this.vars.stock = parseFloat(raw).toLocaleString().replace(/[.,]/g, m => m === '.' ? ',' : '.')
					this.models.stock = Number(raw)
				}
			},
			price: {
				get() {
					return this.vars.price
				}, 
				set(val) {
					let raw = val.replace(/\D/g, '');
					if(raw === '') raw = 0
					this.vars.price = parseFloat(raw).toLocaleString().replace(/[.,]/g, m => m === '.' ? ',' : '.')
					this.models.price = Number(raw)
				}
			},
			code: {
				get() {
					return this.models.code
				},
				set(val) {
					this.models.code = val.toUpperCase()
				}
			},
		},
		methods: {
			getById() {
				if (this.$route.params.id) {
					this.$axios.get(`${api.products}/${this.$route.params.id}`)
						.then(res => {
							const { data } = res.data;
							this.models.name = data.name;
							this.vars.image = data.image;
							this.models.description = data.description;
							this.models.isActive = data.isActive;
							this.models.type = data.type;
							this.models.code = data.type === 'voucher' && data.code;
							this.models.brandId = data.brand.id
							
							const types = ['price', 'stock', 'point']
							types.forEach(type => {
								this.vars[type] = parseFloat(data[type]).toLocaleString().replace(/[.,]/g, m => m === '.' ? ',' : '.')
								this.models[type] = Number(data[type])
								if(type === 'price' && data.type === 'voucher') {
									this.vars[type] = ''
									this.models[type] = 0
								} 
							})
						}).catch(() => this.$router.push({
							name: 'page404'
						}));
				}
			},

			getBrands() {
				this.$axios.get(api.misc_brands).then(res => {
					res.data.data.map(brand => {
						this.masters.brands.push({
							text: brand.name,
							value: brand.id
						})
					})
				});
			},
			
			AddPhoto(event) {
				let fileSizeLimit = 1024 * 1024 * 2; // limit 2 MB
				if(event.target.files[0].size < fileSizeLimit) {
					this.vars.image = event.target.files[0];
				} else {
					this.$showToast('Failed', `Max file size is 2 MB`, 'danger')
				}
			},

			save() {
				this.$validator.validate().then(async valid => {
					if (valid) {
						let request = "";
						let message = "create"

						this.models.image = typeof this.vars.image === 'string' ? this.vars.image : await uploadFile(this.vars.image)
						if(this.models.price === '' || this.models.type === 'voucher') this.models.price = 0

						if(this.models.type === 'product') {
							this.models.code = ''
						}

						if (!this.$route.params.id) {
							request = this.$axios.post(api.products, this.models);
						} else {
							message = "update"
							request = this.$axios.put(`${api.products}/${this.$route.params.id}`, this.models);
						}
						request
							.then(() => {
								this.$showToast('Success', `Success ${message} product`,)
								this.$router.push({
									name: this.config.uri
								})
							})
							.catch(error => this.$refs.response.setResponse(error.response.data, 'danger'));
					} else {
						window.scrollTo(0, 0);
					}
				});
			},
		},
	}
</script>